/* istanbul ignore next */

/**
 * Implementation of the xmlHttpclient implementing async promises
 */
export interface IHttpClient {

    /**
     * Set a value for the HttpHeaders for every request
     * @param key name of the header
     * @param value value of the header
     */
    setHttpHeader(key: string, value: any): IHttpClient;

    /**
     * Send a HttpGet request to an endpoint
     * @param path Uri extra path parameter
     */
    httpGetAsync<TModel>(path?: string): Promise<TModel>;
}

/** This is just to force the compiler to generate .d.ts for interfaces */
export function _IHttpClient(): void { } export default IHttpClient;